import { isPlatformBrowser } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'component-back-to-top',
  templateUrl: './back-to-top.component.html',
})
export class BackToTopComponent {
  @ViewChild('backToTopButton', { static: false }) backToTopButton!: ElementRef; // Ensure backToTopButton is dynamically queried
  private isBrowser: boolean;
  scrollOffset = 600;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    if (!this.isBrowser || !this.backToTopButton) return; // Ensure it only runs in the browser

    const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if (scrollPosition > this.scrollOffset) {
      this.renderer.addClass(this.backToTopButton.nativeElement, 'show');
    } else {
      this.renderer.removeClass(this.backToTopButton.nativeElement, 'show');
    }
  }

  scrollToTop() {
    if (!this.isBrowser) return; // Ensure it only runs in the browser
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
